// Progress / error card for a clip that has not been transcribed yet.
import type { ViewClip } from '../lib/api';
import { formatDuration } from '../lib/format';
import { Icon } from './Icon';

interface ClipStatusCardProps {
  clip: ViewClip;
  online: boolean;
  onRetry: () => void;
}

export function ClipStatusCard({ clip, online, onRetry }: ClipStatusCardProps) {
  const duration = clip.durationMs ? ` (${formatDuration(clip.durationMs)})` : '';
  if (clip.localPending) {
    return (
      <div className="status-card status-card--local" role="status">
        <Icon name="clock" className="status-card__icon" />
        <div>
          <p className="status-card__title">{online ? 'Pošiljam posnetek na strežnik …' : 'Čaka na prenos (brez povezave)'}</p>
          <p className="muted small">
            Posnetek{duration} je varno shranjen v tej napravi in se samodejno pošlje, ko bo povezava na voljo. Ne brišite podatkov brskalnika.
          </p>
        </div>
      </div>
    );
  }
  switch (clip.status) {
    case 'queued':
    case 'processing':
      return (
        <div className="status-card status-card--pending" role="status">
          <Icon name="spinner" className="status-card__icon" />
          <div>
            <p className="status-card__title">{clip.status === 'queued' ? 'Čaka na prepis …' : 'Prepisujem …'}</p>
            <p className="muted small">To lahko traja nekaj minut{duration ? `, odvisno od dolžine posnetka${duration}` : ''}. Stran lahko medtem zaprete.</p>
          </div>
        </div>
      );
    case 'error':
      return (
        <div className="status-card status-card--error" role="alert">
          <Icon name="alert" className="status-card__icon" />
          <div className="status-card__content">
            <p className="status-card__title">Prepis ni uspel</p>
            <p className="small">{clip.error || 'Pri prepisu je prišlo do napake.'}</p>
            {clip.hasAudio && (
              <button type="button" className="btn btn--secondary btn--small" onClick={onRetry}>
                <Icon name="refresh" size={18} /> Poskusi znova
              </button>
            )}
          </div>
        </div>
      );
    case 'done':
      return null;
  }
}
